
import { get, post } from '@/utils/request'
export default {
  namespaced: true,
  state: {
  },
  getters: {

  },
  mutations: {

  },
  actions: {
    // 获取AI试卷总评
    async getShijuanUserInfo(context, params) {
      const res = await get('/Study/analyse/getShijuanUserInfo', params)
      return res
    },
    // 试卷分析报告 -- 获取知识点详情
    async getKpointInfoByShijuanId(context, params) {
      const res = await get('/Study/analyse/getKpointInfoByShijuanId', params)
      return res
    },
    // 试卷分析报告 -- 获取知识点详情
    async getShijuanKpointVideoTime(context, params) {
      const res = await get('/Study/analyse/getShijuanKpointVideoTime', params)
      return res
    },
    // 基础数据
    async getShijuanBasicData(context, params) {
      const res = await get('/Study/analyse/getShijuanBasicData', params)
      return res
    },
    // 获取试卷详情
    async getShijuanShitiList(context, params) {
      const res = await get('/Study/analyse/getShijuanShitiList', params)
      return res
    },
    async getShiJuanZonglanInfo(context, params) {
      const res = await get('/Study/analyse/getShiJuanZonglanInfo', params)
      return res
    },
    // 错题收集 获取作业图片坐标
    async getWorkPictureShitiInfo(context, params) {
      // const res = await get('/Study/analyse/getWorkPictureShitiInfo', params)
      const res = await get('/Study/analyse/getCozePiGaiShitiInfo', params)
      return res
    },
    // 获取作业分析报告
    async getWorkTutoringReport(context, params) {
      const res = await get('/Study/tutoring/getWorkTutoringReport', params)
      return res
    },
    // 错题训练营报告
    async getPracticeReportInfo(context, params) {
      const res = await get('/Study/error/shiti/getPracticeReportInfo', params)
      return res
    },
    // 学情报告详情
    async getUserKpointReportInfo(context, params) {
      const res = await get('/Study/kpoint/report/getUserKpointReportInfo', params)
      return res
    },
    // 英语学习报告详情
    async getstudyReportInfo(context, params) {
      const res = await post('/Study/tool/v1/study-report/get', params)
      return res
    }
  }
}
